import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginComponent } from '../login/login.component';
import { QueryService } from '../../comun/services/query.service';

@Component({
  selector: 'app-remember',
  templateUrl: './remember.component.html',
  styleUrl: './remember.component.css'
})
export class RememberComponent {
  form: FormGroup;
  error: string = '';
  aviso: string = '';
  busy: boolean = false;

  constructor(public login: LoginComponent,
              private fb: FormBuilder,
              private query: QueryService)
  {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  recordarPassword() {
    this.busy = true;
    this.aviso = '';
    this.error = '';
    const formData = this.form.value;
    this.query.query('solicitar_recuperacion', null, { email: formData.email }).subscribe((resultado:any) => {
      if (resultado.resultado == 'ERROR')
        this.error = resultado.mensaje;
      else if (resultado.resultado == 'OK')
        this.aviso = resultado.mensaje;
      this.busy = false;
    });
  }

  Volver() {
    window.location.reload();
  }

}
